import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from 'theme/withStyles';
import RawHtml from 'common/RawHtml';
import GroupsNav from 'groups/GroupsNav';
import renderGroups from 'utils/renderGroups';
import ErrorMsg from 'common/ErrorMsg';

import rootStyles from './styles/root';

const styles = (theme) => {
  const common = {
    root: rootStyles(theme),
  };
  return {
    ...common,
    root: {
      ...common.root,
      // TODO: below styles re-implement the old design. This will be removed in a future story.
      '& .btn-grp-back': {
        display: 'none',
      },
      '& .btn-row-group': {
        display: 'flex',
      },
      '& .grp-label': {
        [`@media(max-width: ${theme.screenSizes.mobileMax}px)`]: {
          display: 'none',
        },
      },
      '& .region-groups form': {
        '& fieldset': {
          margin: [0, 0, 40, 0],
          maxWidth: theme.forms.maxWidth,
          padding: [0, theme.spacing.md],
        },
        display: 'flex',

        justifyContent: 'center',
      },
      maxWidth: '100%',
    },
  };
};

export const StartBare = ({ classes, groups, headerHtml }) => (
  <div className={classnames('start-view', classes.root)}>
    <RawHtml>{headerHtml}</RawHtml>

    <ErrorMsg type="page" />

    <div className="row">
      <div className="widget">
        <div className="region-groups-nav">
          <GroupsNav />
        </div>
        <div className="region-groups">{renderGroups(groups)}</div>
      </div>
    </div>
  </div>
);

StartBare.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  groups: PropTypes.shape({}).isRequired,
  headerHtml: PropTypes.string,
};

StartBare.defaultProps = {
  headerHtml: null,
};

const mapStateToProps = ({ groups, page }) => ({
  groups,
  headerHtml: page.headerHtml,
});

const StartStyled = withStyles(styles)(StartBare);

export default connect(mapStateToProps)(StartStyled);
